module.exports = __webpack_public_path__ + "img/instagram.f54c8e87.png";